import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Form from "../../components/common/form/Form";
import {getFormData} from "../../models/transactionModel";
import {transactionSchema} from "../../schema/transactionScehma";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {createTransaction} from "../../store/transaction-slice";
import {fetchNotApplicableList} from "../../store/list-slice";

const TransactionAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const list = useSelector(state => state.list);

    const {
        createStatus,
        error
    } = useSelector(state => state.transaction);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId,
            amount: Number(data.amount),
        }
        dispatch(createTransaction({...userRole, data: updatedData}));
    }

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const initialData = getFormData()
    const schema = transactionSchema({list});

    return (
        <>
            <SubHeader title="Add Transaction">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransactionAdd;